export const PROD_URL = 'https://shoekicker-blog-dev.netlify.com'
export const DEV_URL = 'http://localhost:8000'
export const siteTitle = 'Shoekicker Blog'

export const styledBox = {
  maxWidth: 820,
  margin: '0 auto',
  padding: 40,
  outline: '1px solid grey',
  backgroundColor: '#fff',
}
